/**
 * Add delay based on parameter duration
 * @param {Number} duration - time in milisecond
 * @returns {Promise}
 */
export function delay(duration) {
  return new Promise((resolve) => setTimeout(resolve, duration));
}
